import angular from 'angular';
import insurerBrochures from './insurerBrochures';
import insurerBrochuresList from './insurerBrochuresList';
import './style.scss';

export default angular
  .module('components.insurerBrochures', [])
  .component('insurerBrochures', insurerBrochures)
  .component('insurerBrochuresList', insurerBrochuresList).name;
